import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-laptop",
  "use": "icon-laptop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-laptop\"><g fill=\"currentColor\"><path d=\"M5.143 5.143c-.947 0-1.714.767-1.714 1.714v8.572c0 .946.767 1.714 1.714 1.714h13.714c.947 0 1.714-.768 1.714-1.714V6.857c0-.947-.767-1.714-1.714-1.714H5.143zm0-1.714h13.714a3.429 3.429 0 0 1 3.429 3.428v8.572a3.429 3.429 0 0 1-3.429 3.428H5.143a3.429 3.429 0 0 1-3.429-3.428V6.857A3.429 3.429 0 0 1 5.143 3.43z\" /><circle cx=\"12\" cy=\"11.143\" r=\"1\" /><circle cx=\"15.429\" cy=\"11.143\" r=\"1\" /><circle cx=\"8.571\" cy=\"11.143\" r=\"1\" /><path d=\"M0 17.143h24v.714a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.714z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-laptop.svg
// module id = 877
// module chunks = 74